/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Sections_Upcomingoffers1Inputs */

const id_home_sections_upcomingoffers1 = /** @type {(inputs: Home_Sections_Upcomingoffers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Penawaran Mendatang`)
};

const ms_home_sections_upcomingoffers1 = /** @type {(inputs: Home_Sections_Upcomingoffers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tawaran Akan Datang`)
};

const da_home_sections_upcomingoffers1 = /** @type {(inputs: Home_Sections_Upcomingoffers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kommende Tilbud`)
};

const de_home_sections_upcomingoffers1 = /** @type {(inputs: Home_Sections_Upcomingoffers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bevorstehende Angebote`)
};

const en_us2_home_sections_upcomingoffers1 = /** @type {(inputs: Home_Sections_Upcomingoffers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Upcoming Offers`)
};

const es_es2_home_sections_upcomingoffers1 = /** @type {(inputs: Home_Sections_Upcomingoffers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Próximos lanzamientos`)
};

const es_mx2_home_sections_upcomingoffers1 = /** @type {(inputs: Home_Sections_Upcomingoffers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Próximas ofertas`)
};

const fil_home_sections_upcomingoffers1 = /** @type {(inputs: Home_Sections_Upcomingoffers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mga Paparating na Offer`)
};

const fr_home_sections_upcomingoffers1 = /** @type {(inputs: Home_Sections_Upcomingoffers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Offres à venir`)
};

const it_home_sections_upcomingoffers1 = /** @type {(inputs: Home_Sections_Upcomingoffers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prossime offerte`)
};

const hu_home_sections_upcomingoffers1 = /** @type {(inputs: Home_Sections_Upcomingoffers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Közelgő ajánlatok`)
};

const nl_home_sections_upcomingoffers1 = /** @type {(inputs: Home_Sections_Upcomingoffers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aankomende aanbiedingen`)
};

const no_home_sections_upcomingoffers1 = /** @type {(inputs: Home_Sections_Upcomingoffers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kommende tilbud`)
};

const pl_home_sections_upcomingoffers1 = /** @type {(inputs: Home_Sections_Upcomingoffers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nadchodzące oferty`)
};

const pt_br2_home_sections_upcomingoffers1 = /** @type {(inputs: Home_Sections_Upcomingoffers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Próximos lançamentos`)
};

const pt_home_sections_upcomingoffers1 = /** @type {(inputs: Home_Sections_Upcomingoffers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Próximas ofertas`)
};

const ro_home_sections_upcomingoffers1 = /** @type {(inputs: Home_Sections_Upcomingoffers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oferte viitoare`)
};

const fi_home_sections_upcomingoffers1 = /** @type {(inputs: Home_Sections_Upcomingoffers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tulevat tarjoukset`)
};

const sv_home_sections_upcomingoffers1 = /** @type {(inputs: Home_Sections_Upcomingoffers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kommande erbjudanden`)
};

const vi_home_sections_upcomingoffers1 = /** @type {(inputs: Home_Sections_Upcomingoffers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ưu đãi sắp tới`)
};

const tr_home_sections_upcomingoffers1 = /** @type {(inputs: Home_Sections_Upcomingoffers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yaklaşan Teklifler`)
};

const cs_home_sections_upcomingoffers1 = /** @type {(inputs: Home_Sections_Upcomingoffers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nadcházející nabídky`)
};

const bg_home_sections_upcomingoffers1 = /** @type {(inputs: Home_Sections_Upcomingoffers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Предстоящи оферти`)
};

const ru_home_sections_upcomingoffers1 = /** @type {(inputs: Home_Sections_Upcomingoffers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Предстоящие предложения`)
};

const uk_home_sections_upcomingoffers1 = /** @type {(inputs: Home_Sections_Upcomingoffers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Майбутні пропозиції`)
};

const ar_home_sections_upcomingoffers1 = /** @type {(inputs: Home_Sections_Upcomingoffers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`العروض القادمة`)
};

const hi_home_sections_upcomingoffers1 = /** @type {(inputs: Home_Sections_Upcomingoffers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`आगामी ऑफ़र`)
};

const th_home_sections_upcomingoffers1 = /** @type {(inputs: Home_Sections_Upcomingoffers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ข้อเสนอที่กำลังจะมา`)
};

const ja_home_sections_upcomingoffers1 = /** @type {(inputs: Home_Sections_Upcomingoffers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`今後のオファー`)
};

const zh_cn2_home_sections_upcomingoffers1 = /** @type {(inputs: Home_Sections_Upcomingoffers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`即将到来的目录项`)
};

const zh_hant1_home_sections_upcomingoffers1 = /** @type {(inputs: Home_Sections_Upcomingoffers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`即將到來的目錄項目`)
};

const ko_home_sections_upcomingoffers1 = /** @type {(inputs: Home_Sections_Upcomingoffers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`출시 예정 오퍼`)
};

/**
* | output |
* | --- |
* | "Upcoming Offers" |
*
* @param {Home_Sections_Upcomingoffers1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const home_sections_upcomingoffers1 = /** @type {((inputs?: Home_Sections_Upcomingoffers1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Sections_Upcomingoffers1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_home_sections_upcomingoffers1(inputs)
	if (locale === "ms") return ms_home_sections_upcomingoffers1(inputs)
	if (locale === "da") return da_home_sections_upcomingoffers1(inputs)
	if (locale === "de") return de_home_sections_upcomingoffers1(inputs)
	if (locale === "en-US") return en_us2_home_sections_upcomingoffers1(inputs)
	if (locale === "es-ES") return es_es2_home_sections_upcomingoffers1(inputs)
	if (locale === "es-MX") return es_mx2_home_sections_upcomingoffers1(inputs)
	if (locale === "fil") return fil_home_sections_upcomingoffers1(inputs)
	if (locale === "fr") return fr_home_sections_upcomingoffers1(inputs)
	if (locale === "it") return it_home_sections_upcomingoffers1(inputs)
	if (locale === "hu") return hu_home_sections_upcomingoffers1(inputs)
	if (locale === "nl") return nl_home_sections_upcomingoffers1(inputs)
	if (locale === "no") return no_home_sections_upcomingoffers1(inputs)
	if (locale === "pl") return pl_home_sections_upcomingoffers1(inputs)
	if (locale === "pt-BR") return pt_br2_home_sections_upcomingoffers1(inputs)
	if (locale === "pt") return pt_home_sections_upcomingoffers1(inputs)
	if (locale === "ro") return ro_home_sections_upcomingoffers1(inputs)
	if (locale === "fi") return fi_home_sections_upcomingoffers1(inputs)
	if (locale === "sv") return sv_home_sections_upcomingoffers1(inputs)
	if (locale === "vi") return vi_home_sections_upcomingoffers1(inputs)
	if (locale === "tr") return tr_home_sections_upcomingoffers1(inputs)
	if (locale === "cs") return cs_home_sections_upcomingoffers1(inputs)
	if (locale === "bg") return bg_home_sections_upcomingoffers1(inputs)
	if (locale === "ru") return ru_home_sections_upcomingoffers1(inputs)
	if (locale === "uk") return uk_home_sections_upcomingoffers1(inputs)
	if (locale === "ar") return ar_home_sections_upcomingoffers1(inputs)
	if (locale === "hi") return hi_home_sections_upcomingoffers1(inputs)
	if (locale === "th") return th_home_sections_upcomingoffers1(inputs)
	if (locale === "ja") return ja_home_sections_upcomingoffers1(inputs)
	if (locale === "zh-CN") return zh_cn2_home_sections_upcomingoffers1(inputs)
	if (locale === "zh-Hant") return zh_hant1_home_sections_upcomingoffers1(inputs)
	return ko_home_sections_upcomingoffers1(inputs)
});
export { home_sections_upcomingoffers1 as "home.sections.upcomingOffers" }